/* eslint-disable */
import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import PrivateRoute from './src/components/auth/PrivateRoute';
import RootStore from './src/stores/index';
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './src/components/keycloak'
import { keyCloakInitOptions } from './src/utils/constants/AuthConstants';

const Loading = () => <div>Loading...</div>

const wrapPageElement = ({ element, props }) => {
  const { uri } = props;

  if (!/\/auth$/.test(uri) && !/\/logout$/.test(uri)) {
    return <PrivateRoute {...props}>{element}</PrivateRoute>;
  }
};

const wrapRootElement = ({ element }) => {
  const rootStore = new RootStore();
  const store = {
    authStore: rootStore.getAuthStore,
    journeyStore: rootStore.getJourneyStore
  };

  return (<ReactKeycloakProvider
            authClient={keycloak}
            initOptions = {keyCloakInitOptions}
            LoadingComponent={<Loading />}
          >
            <Provider {...store}>{element}</Provider>
          </ReactKeycloakProvider>)
}

if (process.env.NODE_ENV !== 'production') {
  const axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}

export { wrapPageElement, wrapRootElement };
